import React, { useRef,useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";
import { useDispatch } from "react-redux";
import { empresaLimpiar } from "../../actions/empresas/empresas";
import { FormEmpresa } from "./shared/formEmpresa";
import { FORM_ACTIONS } from "../../utils/constants";
import { limpiarDatosSuspensionEmpresa } from "../../actions/comunicacionConEmpresas/comunicacionConEmpresas";
import { limpiarSeguimiento } from "../../actions/empresas/seguimientoEmpresas";

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: "relative",
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const EmpresaAltaModal = ({ empresaABM, abrirModal, setAbrirModal, item}) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    
    useEffect(() => {
        dispatch(limpiarSeguimiento())
        dispatch(limpiarDatosSuspensionEmpresa());
    }, [dispatch])


    const handleClose = () => {
        dispatch(empresaLimpiar());
        setAbrirModal(false);
        dispatch(limpiarSeguimiento())
        dispatch(limpiarDatosSuspensionEmpresa());
    };

    const childRef = useRef();

    return (
        <div>
            <Dialog
                fullScreen
                open={abrirModal}
                onClose={handleClose}
                TransitionComponent={Transition}
            >
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="h6" className={classes.title}>
                            NUEVA EMPRESA
                        </Typography>
                    </Toolbar>
                </AppBar>
                <FormEmpresa empresa={item ? item : {}} action={FORM_ACTIONS.CREAR} ref={childRef} cerrarPop={handleClose} />
            </Dialog>
        </div>
    );
}

export default EmpresaAltaModal